import { useAtomValue } from 'jotai';

import { useActivityReport } from '@queries';
import {
    activityIdAtom,
    convertedLayoutCustomCorridorsMapAtom,
    corridorsAtom,
    selectedActiveAnalysisAtom,
    uiNodeBySmpIdAtom,
} from '@store';

export const useSwingGuideMetric = (smpId: number) => {
    const activeAnalysis = useAtomValue(selectedActiveAnalysisAtom);
    const uiNodesBySmpId = useAtomValue(uiNodeBySmpIdAtom);
    const corridors = useAtomValue(corridorsAtom);
    const activityId = useAtomValue(activityIdAtom);
    const { data: activityReport } = useActivityReport(activityId);
    const goalCorridors = useAtomValue(convertedLayoutCustomCorridorsMapAtom);
    const parameterId = uiNodesBySmpId[smpId]?.parameter.smpId;

    const currentValue = parameterId
        ? activeAnalysis?.data.analysis?.parameter_values?.[parameterId]?.value
        : undefined;

    const reportValue = parameterId ? activityReport?.[parameterId] : undefined;
    const corridor = parameterId ? corridors?.[parameterId] : undefined;
    const goalCorridor = goalCorridors?.[parameterId] ?? undefined;

    return {
        currentValue,
        reportValue,
        corridor,
        goalCorridor,
    };
};
